import { createFormContext } from '@mantine/form';

export const [FormProvider, useFormContext, useForm] = createFormContext<any>();
